<app-error *ngIf="isError" [message]="errorMessage"></app-error>
<form (ngSubmit)="onSubmit()" #feedbackForm="ngForm" ngForm="feedbackForm">
  <div class="form-group">
    <div class="d-flex" style="display: inline !important;">
      <editor name="comment" [init]="init" id="file-picker" ngModel #comment="ngModel"></editor>
    </div>
    <div class="justify-content-left" *ngIf="!feedbackSubmitted">
      <button [ngClass]="(comment.value != '' && comment.value != null)? 'btn-new-ui':'btn-new-ui-disabled'"
              type="submit"
              [disabled]="comment.value === '' || comment.value === null">
        Submit
      </button>
    </div>
  </div>
</form>
<hr />
<span *ngIf="isListloading" class="justify-content-center">
  <app-loading [displayeMessage]="true"></app-loading>
</span>
<app-list [currentResponseId]="responseId"></app-list>
